import { CommonTrainInfoFormProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoForm";
import { CommonSubTypeProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoFormModal";
import { AffectedStopsFields } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/subTypeInputs/AffectedStopsFields";
import { TrainContext } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/subTypeInputs/utils/formContextWrappers";
import { EitherTrainFormSchema } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { Distributions } from "features/CenterContent/shared/operationalInformation/components/Distributions";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

export const TrainCustom: FC<
  CommonTrainInfoFormProps & CommonSubTypeProps & TrainContext
> = ({ mode, ...props }) => {
  const { trainFormPrefix } = props;

  const { formState } = useFormContext<EitherTrainFormSchema>();
  const { errors } = formState;

  const contextTypesFieldPath =
    `${trainFormPrefix}.distributions.contextTypes` as const;

  return (
    <>
      <AffectedStopsFields mode={mode} {...props} />
      <Distributions
        contextTypesField={contextTypesFieldPath}
        fieldErrors={errors}
      />
    </>
  );
};
